import { createSlice } from "@reduxjs/toolkit";
import {
  checkAuthStatus,
  forgotPassword,
  loginUser,
  logoutUser,
  SetupNewPassword,
  verifyTwoFactorCode,
} from "./authThunks";

const initialState = {
  user: null,
  member: null,
  loading: false,
  error: null,
  hasChecked: false, // ✅ new
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.member = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user || action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(SetupNewPassword.fulfilled, (state, action) => {
        state.member = action.payload;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.member = action.payload;
      })
      .addCase(verifyTwoFactorCode.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user || action.payload;
        state.userData = action.payload.userData || null;

        if (state.userData) {
          localStorage.setItem("member", JSON.stringify(state.userData));
        }
      })
      .addCase(checkAuthStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.hasChecked = true;
        state.user = action.payload.user || action.payload;
        state.userData = action.payload.userData || null;

        if (state.user) {
          localStorage.setItem("user", JSON.stringify(state.user)); // <-- Store user info
        }
        if (state.userData) {
          localStorage.setItem("member", JSON.stringify(state.userData));
        }
      })
      .addCase(checkAuthStatus.rejected, (state, action) => {
        state.user = null;
        state.error = action.payload;
        state.loading = false;
        state.hasChecked = true;
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.user = null;
        state.member = null;
        localStorage.removeItem("user");
        localStorage.removeItem("member");
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
